import { render, staticRenderFns } from "./DialogEditName.vue?vue&type=template&id=d53c6da2&scoped=true"
import script from "./DialogEditName.vue?vue&type=script&lang=js"
export * from "./DialogEditName.vue?vue&type=script&lang=js"
import style0 from "./DialogEditName.vue?vue&type=style&index=0&id=d53c6da2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53c6da2",
  null
  
)

export default component.exports